export const blockInvalidChar = e =>
    e.target.type.toLowerCase() === "number" &&
    ['e', 'E', '+', '-'].includes(e.key)
    && e.preventDefault();
